import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import ExportAnalysisButton from "./ExportAnalysisButton";
import { Tooltip } from "@mui/material";
import { projectDataPropType } from "../util/propTypeHelper";
import { navigateWithAlert } from "../util/formHelpers";

export const PROGRESS_STEPPER_WIDTH = "245px";
export const BOTTOM_BAR_HEIGHT = 80;

const defaultStyle = {
  bottom: 0,
  height: `${BOTTOM_BAR_HEIGHT}px`,
  left: 0,
  position: "absolute",
  right: 0,
};

export default function BottomBar({
  handleSecondaryButtonClick,
  isFullScreenWidth = false,
  isLoading,
  mainButtons = [{}],
  projectData,
  secondaryButtonLabel = "Back",
  style = defaultStyle,
  withSubmitButton = true,
  isFormDirty = false,
}) {
  return (
    <div
      data-testid="BottomBar"
      style={{
        backgroundColor: "#FFF",
        display: "flex",
        justifyContent: "space-between",
        width: isFullScreenWidth
          ? ""
          : `calc(100vw - ${PROGRESS_STEPPER_WIDTH})`,
        ...style,
      }}
    >
      <ExportAnalysisButton projectData={projectData} />

      <div style={{ display: "flex" }}>
        <Button
          onClick={(event) =>
            navigateWithAlert({
              event,
              isFormDirty,
              navigate: handleSecondaryButtonClick,
            })
          }
          style={{ margin: "20px" }}
        >
          {secondaryButtonLabel}
        </Button>
        {mainButtons?.map(
          ({ isDisabled, label = "Next", onClick, tooltipText }) => {
            return (
              <Tooltip key={label} title={tooltipText}>
                <div
                  data-testid={`${label}-buttonWrapper`}
                  style={{ pointerEvents: "auto" }}
                >
                  <Button
                    color="success"
                    disabled={isDisabled || isLoading}
                    onClick={withSubmitButton ? () => {} : onClick}
                    sx={{
                      marginRight: "30px",
                      margin: "20px",
                      minWidth: "120px",
                    }}
                    type={withSubmitButton ? "submit" : "button"}
                    variant="contained"
                  >
                    {isLoading ? "Loading..." : label}
                  </Button>
                </div>
              </Tooltip>
            );
          }
        )}
      </div>
    </div>
  );
}

BottomBar.propTypes = {
  handleSecondaryButtonClick: PropTypes.func.isRequired,
  isFormDirty: PropTypes.bool,
  isFullScreenWidth: PropTypes.bool,
  isLoading: PropTypes.bool,
  mainButtons: PropTypes.arrayOf(
    PropTypes.shape({
      isDisabled: PropTypes.bool,
      label: PropTypes.string,
      onClick: PropTypes.func,
    })
  ),
  projectData: projectDataPropType.isRequired,
  secondaryButtonLabel: PropTypes.string,
  style: PropTypes.object,
  withSubmitButton: PropTypes.bool,
};
